import { Stepper } from '@/components/ui/Stepper';
import { peekJourneyRoute } from '@/lib/auth/intent-storage';
import {
  ISSUE_REPORT_JOURNEY_BAR,
  type IssueReportJourneyStage,
  type JourneyRoute,
} from '@/lib/constants/issue-report';

export interface IssueReportJourneyStepsProps {
  stage: IssueReportJourneyStage;
  /**
   * Register or log in; decides the steps. Defaults to the route stored with
   * the intent. Pass it where the page itself is the route (signup, login) or
   * where the intent is cleared while the bar is still on screen.
   */
  route?: JourneyRoute;
  /** Spacing from the screen's content. */
  className?: string;
}

/**
 * The Issue Report journey's progress bar (FR-224), shared by the auth,
 * journey and billing screens it spans. Built on the `Stepper` primitive, not
 * a second stepper. Its steps follow the route the visitor took: four when
 * registering, three when logging in. The screen decides whether the journey
 * is in progress.
 */
export function IssueReportJourneySteps({
  stage,
  route = peekJourneyRoute(),
  className = '',
}: IssueReportJourneyStepsProps) {
  const bar = ISSUE_REPORT_JOURNEY_BAR[route];
  return (
    <nav
      aria-label="Issue Report progress"
      className={`mx-auto w-full max-w-3xl ${className}`.trim()}
    >
      <Stepper steps={[...bar.steps]} currentIndex={bar.index[stage]} />
    </nav>
  );
}
